interface ErrorType {
  headerText: string;
  bodyText: string;
  error?: string;
  buttonText: {
    one: string;
    two: string;
  };
}
/**
 *
 * @param errorType What error we recieved
 * @returns variable of translation text that should be displayed in errorModal
 */

export const createErrorObject = (errorType: string) => {
  const errors: { [key: string]: ErrorType } = {
    noUserMedia: {
      headerText: "ErrorModalNoUserMediaHeader",
      bodyText: "ErrorModalNoUserMediaBody",
      error: errorType,
      buttonText: {
        one: "Reconnect",
        two: "ReturnToHome",
      },
    },
    serverConnectionFailed: {
      headerText: "ErrorModalServerConnectionFailedHeader",
      bodyText: "ErrorModalServerGenericBody",
      buttonText: {
        one: "StartAgain",
        two: "ProvideFeedback",
      },
    },
    timeout: {
      headerText: "ErrorModalServerSessionTimeoutHeader",
      bodyText: "ErrorModalServerGenericBody",
      buttonText: {
        one: "StartAgain",
        two: "ProvideFeedback",
      },
    },
    userInteraction: {
      headerText: "",
      bodyText: "ErrorModalUserInteractionBody",
      buttonText: {
        one: "StartVideo",
        two: "",
      },
    },
  };
  return errors[errorType]
    ? errors[errorType]
    : {
        headerText: "ErrorModalGenericHeader",
        bodyText: "ErrorModalGenericBody",
        buttonText: {
          one: "StartAgain",
          two: "ProvideFeedback",
        },
      };
};
